<template>

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Cortes Diarios</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-8">
          <vs-card>
            <div class="flex items-end justify-between">
              <vs-input label="De" v-model="from" type="date"></vs-input>
              <vs-input label="A" v-model="to" type="date"></vs-input>
              <vs-button color="primary" v-on:click="getDailyCuts()">Buscar</vs-button>
            </div>
          </vs-card>
        </div>
      </div>
      <div class="row justify-content-md-center mt-10">
        <div class="col-md-12">
          <vs-card>
            <vs-table :data="data">
              <template slot="thead">
                <vs-tr>
                  <vs-th>Archivo</vs-th>
                  <vs-th>Estado</vs-th>
                  <vs-th>Acción</vs-th>
                </vs-tr>
              </template>
              <template slot-scope="{data}">
                <vs-tr v-for="item in data" :key="item.archivo">
                  <vs-td>{{item.archivo}}</vs-td>
                  <vs-td>
                    <span class="font-bold" :class="{
                      'text-success': item.estado === 'Generado',
                      'text-danger': item.estado !== 'Generado',
                    }">
                      {{item.estado}}
                    </span>
                  </vs-td>
                  <vs-td>
                    <vs-button
                        class="small mr-2"
                        color="dark"
                        v-if="item.estado === 'Generado'"
                        v-on:click="downloadDailyCut(item)">
                      Descargar
                    </vs-button>
                    <vs-button
                        class="small"
                        v-if="item.estado === 'Generado'"
                        v-on:click="regenerateDailyCut(item.fecha)">
                      Regenerar
                    </vs-button>
                    <vs-button
                        class="small"
                        v-else
                        v-on:click="generateDailyCut(item.fecha)">
                      Generar
                    </vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'daily-cuts',
    props: [],
    mounted() {
      this.from = this.getFrom();
      this.to = this.getTo();
    },
    data() {
      return {
        data: [],
        today: new Date(),
        to2: null,
        to: null,
        from: null,
        disabledDates: date => {
          return date >= this.today ||
                  (date.getFullYear() === this.today.getFullYear() &&
                   date.getMonth() === this.today.getMonth() &&
                   date.getDate() === this.today.getDate());
        },
        disabledDates2: date => {
          return date > new Date(this.to2) || date >= this.today ||
                  (date.getFullYear() === this.today.getFullYear() &&
                          date.getMonth() === this.today.getMonth() &&
                          date.getDate() === this.today.getDate());
        }
      }
    },
    watch:{
      to:function () {
        if(this.from > this.to) this.from = this.to;
        this.to2 = new Date(this.to);
        this.to2.setDate(this.to2.getDate()+1);
      }
    },
    methods: {
      getFrom(){
        var date = new Date();
        date.setDate(date.getDate());
        date.setMonth(date.getMonth()-1);
        if(date.getMonth()<10 && date.getDate()<10) return date.getFullYear()+'-0'+(date.getMonth()+1)+'-0'+date.getDate();
        if(date.getMonth()<10) return date.getFullYear()+'-0'+(date.getMonth()+1)+'-'+date.getDate();
        if(date.getDate()<10) return date.getFullYear()+'-'+(date.getMonth()+1)+'-0'+date.getDate();
        return date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();},
      getTo(){
        var date = new Date();
        date.setDate(date.getDate()-1);
        if(date.getMonth()<9 && date.getDate()<10) return date.getFullYear()+'-0'+(date.getMonth()+1)+'-0'+date.getDate();
        if(date.getMonth()<9) return date.getFullYear()+'-0'+(date.getMonth()+1)+'-'+date.getDate();
        if(date.getDate()<10) return date.getFullYear()+'-'+(date.getMonth()+1)+'-0'+date.getDate();
        return date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()},
      getDailyCuts (){
        this.data = [];
        Vue.toasted.show('Cargando...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/dailycuts', {
          from: this.from,
          to: this.to
        }).then(response => {
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Cortes Diarios cargados correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
          this.data = response.data.data;
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      async regenerateDailyCut(fecha){
        Vue.toasted.show('Generando...', { position: 'bottom-center', closeOnSwipe: false });
        try {
          await axios.post('/api/accounting/dailycuts/generate', {
            fecha: fecha
          })
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Corte Diario del ' + fecha + ' regenerado correctamente !!', {
            position: 'bottom-center',
            type: 'success',
            closeOnSwipe: false,
            duration: 10000
          });
          this.getDailyCuts();
        } catch(e) {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', {
            position: 'bottom-center',
            type: 'error',
            closeOnSwipe: true,
            duration: 10000
          });
        }
      },
      generateDailyCut(fecha){
        Vue.toasted.show('Generando...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/dailycuts/generate', {
          fecha: fecha
        }).then(response => {
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Corte Diario del '+fecha+' generado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
          this.getDailyCuts();
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      downloadDailyCut(renglon) {
        Vue.toasted.show('Descargando...', {position: 'bottom-center', closeOnSwipe: false});
        let downloadLink = document.createElement('a');
        downloadLink.href = 'data:text/csv;base64,' + renglon.download;
        downloadLink.download = renglon.archivo;
        downloadLink.click();
        Vue.toasted.clear();
      }
    },
    computed: {

    }
}
</script>